import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { addSpecimen, updateTableHasChanged, resetRowHasChanged, saveSpecimen, setCaseStatus } from '../../redux/actions';
import { userRoles } from '../../constants/constants';
import SpecimenTableComponent from './specimenTableComponent';
import { caseStatus } from '../../constants';
import _ from 'lodash';


class SpecimenTableForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      specimens: [...props.specimens],
    };
  }

  static getDerivedStateFromProps(props, state) {
    const specimensHasChanges = JSON.stringify(props.specimens) !== JSON.stringify(state.specimens);
    // todo find out more ways to prevent updates
    if (!specimensHasChanges) {
      return null;
    }
    const specimensIsAddedOrDeleted = props.specimens.length !== state.specimens.length;
    let specimensToBe;


    if (specimensIsAddedOrDeleted) {
      if (props.specimens.length > state.specimens.length) {
        // ADD SPECIMENS
        const newSpecimens = props.specimens.filter(specimen => (
          !state.specimens.map(s => s._id).includes(specimen._id)
        ));
        specimensToBe = [...state.specimens, ...newSpecimens];
      } else {
        // DELETE SPECIMENS
        specimensToBe = state.specimens.filter(specimen => (
          props.specimens.map(s => s._id).includes(specimen._id)
        ));
      }
      // update ids
      specimensToBe = specimensToBe.map((s, i) => ({ ...s, id: (i + 1).toString() }));
      return { specimens: specimensToBe };
    }
    let imageIsUploadedOrDeleted = false;
    specimensToBe = state.specimens.map(specimen => {
      const specimenFromProps = props.specimens.find(s => s._id === specimen._id);

      if (specimenFromProps.cadessId !== specimen.cadessId) {
        imageIsUploadedOrDeleted = true;
        return {
          ...specimen,
          cadessId: specimenFromProps.cadessId,
          imgUrl: specimenFromProps.imgUrl,
          cadessImgUrl: specimenFromProps.cadessImgUrl,
          thumbnail: specimenFromProps.thumbnail,
          specimenImage: specimenFromProps.specimenImage,

        };
      } return specimen;
    });

    if (imageIsUploadedOrDeleted) {
      return { specimens: specimensToBe }
    }
    return null;
  }

  handleCreate = () => {
    const { saveSpecimen, caseId, specimens } = this.props;
    const type = 'post';
    const newSpecimen = {
      analysisStarted: false,
      id: (specimens.length + 1).toString(),
      cadessId: '',
      stainType: '',
      specimenLocation: specimens.length,
      lengthOfCores: '',
      totalNumberOfCores: 0,
      caseId: '',
      coordinates: { x: -100, y: -100 },
      imgUrl: '',
      cadessImgUrl: '',
      thumbnail: '',
      specimenImage: '',
      analyses: [],
    };
    saveSpecimen(caseId, newSpecimen, type);
  }

  handleEdit = (specimen) => {
    const { saveSpecimen, caseId } = this.props;
    const type = "put";
    saveSpecimen(caseId, specimen, type);
  }

  handleDelete = (specimen) => {
    const { saveSpecimen, caseId } = this.props;
    const type = 'delete';
    saveSpecimen(caseId, specimen, type);
  }

  handleImageUploaded = (cadessData, specimen) => {
    this.handleEdit({ ...specimen, ...cadessData });
  }

  handleFormValuesChange = (event, specimenId, propertyKey) => {
    const { value } = event.target;
    const { canEdit } = this.props;
    if (!canEdit) return;
    this.setState(previousState => {
      const specimens = previousState.specimens.map((specimen) => {
        if (specimen._id === specimenId) {
          return { ...specimen, [propertyKey]: value };
        }
        return specimen;
      });
      return { specimens };
    });
  }

  handleImageDelete = (specimen) => {
    const imageClearedSpecimen = {
      ...specimen,
      cadessId: '',
      imgUrl: '',
      cadessImgUrl: '',
      thumbnail: '',
      specimenImage: '',
    };
    this.handleEdit(imageClearedSpecimen);
  }

  submitAll = () => {
    const { specimens } = this.state;
    specimens.forEach(specimen => {
      this.handleEdit(specimen);
    });
  }

  /*   submitAllAndSetCaseStatusToAwaitingUpload = () => {
      this.submitAll();
      const { workFlowStatusDemo: { AWAITING_UPLOAD } } = caseStatus;
      const { caseId, setCaseStatus } = this.props;
      setTimeout(setCaseStatus(AWAITING_UPLOAD, caseId), 4000);
    } */

  submitAllAndSetCaseStatusToAwaitingAnalysis = () => {
    this.submitAll();
    const { workFlowStatusDemo: { AWAITING_ANALYSIS } } = caseStatus;
    const { caseId, setCaseStatus } = this.props;
    setTimeout(setCaseStatus(AWAITING_ANALYSIS, caseId), 4000);
  }


  handlePlot = (e, specimenId) => {
    e.persist();
    const dim = document.getElementById('prostateSVG').getBoundingClientRect();
    const coordinates = {
      x: e.clientX - dim.left,
      y: e.clientY - dim.top,
    };

    const { canEdit } = this.props;
    if (!canEdit) return;
    this.setState(previousState => {
      const specimens = previousState.specimens.map((specimen) => {
        if (specimen.id === specimenId) { // nice little mix of id and _id, isn't it? :(
          return { ...specimen, coordinates };
        }
        return specimen;
      });
      return { specimens };
    });
  };

  getHasChanges = () => {
    const { specimens } = this.state;
    const savedSpecimens = this.props.specimens;
    return specimens.some((s, index) => !_.isEqual({ ...s, id: '' }, { ...savedSpecimens[index], id: '' }));
  }


  render() {
    const {
      canEdit,
      canUploadImage,
      cansubmitImage,
    } = this.props;
    const { specimens } = this.state;
    return (
      <>
        <form>
          <SpecimenTableComponent
            handleChange={this.handleFormValuesChange}
            handleDelete={this.handleDelete}
            handleImageUploaded={this.handleImageUploaded}
            handleImageDelete={this.handleImageDelete}
            handlePlot={this.handlePlot}
            canEdit={canEdit}
            canUploadImage={canUploadImage}
            specimens={specimens}
          />
        </form>


        {canEdit && (
          <Button
            className="btn--form"
            style={{ marginBottom: '20px', backgroundColor: 'white' }}
            type="button"
            onClick={this.handleCreate}
          >
            Add Specimen
          </Button>
        )}
        {canEdit && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '4px' }}>
            <Button
              onClick={this.submitAll}
              variant="contained"
              style={{ backgroundColor: 'white' }}
              disabled={!this.getHasChanges()}
            >
              Save
            </Button>
          </div>
        )}
        {/*       {(canEdit && cansubmitFields) && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '4px' }}>
            <Button
              onClick={this.submitAllAndSetCaseStatusToAwaitingUpload}
              variant="contained"
              title="Save And Mark Specimen Fields As Done"
              style={{ backgroundColor: 'white' }}
            >
              Mark Fields As Done
            </Button>
          </div>
        )} */}

        {(canUploadImage && cansubmitImage) && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '4px' }}>
            <Button
              onClick={this.submitAllAndSetCaseStatusToAwaitingAnalysis}
              variant="contained"
              color="primary"
            >
              Submit Images
            </Button>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ auth, _case }) => {
  const { user } = auth;
  const { specimens, selectedCase } = _case;

  const { workFlowStatusDemo: { CASE_CREATED, AWAITING_UPLOAD } } = caseStatus;
  const canEdit = user.role === userRoles.admin
    || (user.role === userRoles.surgeon && selectedCase.status.workFlowStatusDemo === CASE_CREATED);
  const canUploadImage = user.role === userRoles.admin
    || (user.role === userRoles.technician && selectedCase.status.workFlowStatusDemo === AWAITING_UPLOAD);


  const cansubmitFields = (selectedCase.status.workFlowStatusDemo === CASE_CREATED)
    && (specimens.length > 0);

  const cansubmitImage = (selectedCase.status.workFlowStatusDemo === AWAITING_UPLOAD)
    && (specimens.length > 0)
    && (!specimens.map(s => s.cadessId).includes(''));// no emty images

  return {
    canEdit,
    canUploadImage,
    cansubmitFields,
    cansubmitImage,
    specimens,
    caseId: selectedCase.id,
  };
};

export default connect(mapStateToProps, {
  addSpecimen, updateTableHasChanged, resetRowHasChanged, saveSpecimen, setCaseStatus,
})(SpecimenTableForm);
